import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { Brain, Share2, Target, TrendingUp } from "lucide-react"

const features = [
  {
    title: "Semantic Content Networks",
    description: "Learn to build comprehensive content networks that establish topical authority through semantic relationships",
    icon: Brain,
    ariaLabel: "Semantic Content Networks feature"
  },
  {
    title: "Contextual Optimization",
    description: "Master the art of contextual vectors and hierarchies to optimize content relevance",
    icon: Target,
    ariaLabel: "Contextual Optimization feature"
  },
  {
    title: "No-Link Authority",
    description: "Build authority without relying on traditional link building techniques",
    icon: Share2,
    ariaLabel: "No-Link Authority feature"
  },
  {
    title: "Ranking Strategies",
    description: "Proven strategies to outrank established authorities with strategic content development",
    icon: TrendingUp,
    ariaLabel: "Ranking Strategies feature"
  }
]

export function Features() {
  return (
    <section className="py-12 bg-card/50" aria-label="Core Framework Components">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-12">Core Framework Components</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="backdrop-blur-lg border-primary/20 transition-all duration-300 hover:shadow-lg hover:border-primary/40"
              aria-label={feature.ariaLabel}
            >
              <CardHeader>
                <feature.icon className="h-12 w-12 text-primary mb-4" aria-hidden="true" />
                <CardTitle>{feature.title}</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-muted-foreground">{feature.description}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}